export default __webpack_public_path__ + "static/media/Snd_X_Starts.173ee8cd.mp3";